import {
    StyleSheet,
    Platform
} from "react-native";
import {
    type HighlightButtonSolidColorConstantType,
    type HighlightButtonGlassConstantType,
    type HighlightButtonTypeConstantType,
    type HighlightButtonGlass,
    type HighlightButtonType
} from "./type";
import {
    getTypeColors
} from "../../helpers/theme/typeColors";
import type {
    ButtonType
} from "../button/type";
import {
    getOpaqueColor,
    webStyle
} from "../../utils";
import {
    withAlpha
} from "../../utils/color";

export const HIGHLIGHT_BUTTON_TYPES: Record<HighlightButtonType, ButtonType> = {
    neutral: "neutral",
    primary: "primary",
    success: "success",
    warning: "warning",
    danger: "danger",
    glass: "neutral",
    info: "info"
};

export const getHighlightButtonType = ({
    isPlainBackground,
    type
}: HighlightButtonTypeConstantType): ButtonType => {
    return HIGHLIGHT_BUTTON_TYPES[isPlainBackground ? "neutral" : type];
};

export const getHighlightButtonGlass = ({
    glassEffect,
    colors,
    glass
}: HighlightButtonGlassConstantType): HighlightButtonGlass => {
    const tint = colors.content.text.contrastHigh;

    const blur = `blur(${glassEffect}px)`;

    return {
        color: withAlpha({
            alpha: Platform.OS === "web" ? glass.fillAlpha : glass.nativeFillAlpha,
            color: tint
        }),
        style: webStyle({
            WebkitBackdropFilter: blur,
            backdropFilter: blur
        }),
        borderColor: withAlpha({
            alpha: glass.edgeAlpha,
            color: tint
        }),
        titleColor: tint
    };
};

// The neutral tonal fill is translucent; laid over the page ground it stays solid on photos and busy backgrounds.
export const getHighlightButtonSolidColor = ({
    colors,
    type
}: HighlightButtonSolidColorConstantType): string => {
    return getOpaqueColor({
        surface: colors.content.container.default,
        color: getTypeColors({
            variant: "tonal",
            colors,
            type
        }).containerColor
    });
};

const stylesheet = StyleSheet.create({
});
export default stylesheet;
